// extracted by mini-css-extract-plugin
export default {"buttonList":"BtnList_buttonList__k7pXU","white":"BtnList_white__7EPFi","black":"BtnList_black__A-3eU"};